// extracted by mini-css-extract-plugin
export default {"theme_switch":"Header_theme_switch__BXqUM"};